import { createRouter, createWebHistory } from "vue-router";

function loadBibliographyPage() {
    return () =>
        import(
            /* webpackChunkName: "bibliography" */ "./pages/IndexBibliography.vue"
        );
}

function loadHomepage() {
    return () => import(/* webpackChunkName: "main" */ "./pages/Home.vue");
}

function loadDocumentsPage() {
    return () => import(/* webpackChunkName: "main" */ "./pages/Documents.vue");
}

function loadDocumentPage() {
    return () => import(/* webpackChunkName: "main" */ "./pages/Document.vue");
}

function loadIndexNamesPage() {
    return () =>
        import(/* webpackChunkName: "main" */ "./pages/IndexNames.vue");
}

function loadIndexBiblePassagesPage() {
    return () =>
        import(/* webpackChunkName: "main" */ "./pages/IndexBiblePassages.vue");
}

function loadIndexMotifsPage() {
    return () =>
        import(/* webpackChunkName: "main" */ "./pages/IndexMotifs.vue");
}

function loadImprintPage() {
    return () => import(/* webpackChunkName: "main" */ "./pages/Imprint.vue");
}

function loadDirectoriesPage() {
    return () =>
        import(
            /* webpackChunkName: "directories" */ "./pages/IndexKeywords.vue"
        );
}

function loadNetworkPage() {
    return () =>
        import(/* webpackChunkName: "network" */ "./pages/Network.vue");
}

function loadProjectPage() {
    return () =>
        import(/* webpackChunkName: "project" */ "./pages/Project.vue");
}
function loadTeamPage() {
    return () =>
        import(/* webpackChunkName: "project" */ "./pages/TeamProject.vue");
}
function loadSearchPage() {
    return () =>
        import(/* webpackChunkName: "search" */ "./pages/SearchResults.vue");
}

function loadTextTocPage() {
    return () => import(/* webpackChunkName: "toc" */ "./pages/IndexText.vue");
}

function loadManuscriptTocPage() {
    return () =>
        import(/* webpackChunkName: "toc" */ "./pages/IndexManuscript.vue");
}

function loadIncunableTocPage() {
    return () =>
        import(/* webpackChunkName: "toc" */ "./pages/IndexIncunable.vue");
}

function loadDocumentationPage() {
    return () =>
        import(/* webpackChunkName: "doc" */ "./pages/Documentation.vue");
}

function loadDSGVOPage() {
    return () => import(/* webpackChunkName: "doc" */ "./pages/Dsgvo.vue");
}
function loadAccessibilityPage() {
    return () =>
        import(/* webpackChunkName: "doc" */ "./pages/Accessibility.vue");
}
function loadEasyLanguagePage() {
    return () =>
        import(/* webpackChunkName: "doc" */ "./pages/EasyLanguage.vue");
}
function loadLicences() {
    return () => import(/* webpackChunkName: "doc" */ "./pages/Licences.vue");
}
function loadTechnicalDocumentation() {
    return () =>
        import(
            /* webpackChunkName: "doc" */ "./pages/TechnicalDocumentation.vue"
        );
}
function loadCitationPage() {
    return () => import(/* webpackChunkName: "doc" */ "./pages/Citation.vue");
}
function loadAbbreviationsPage() {
    return () =>
        import(/* webpackChunkName: "doc" */ "./pages/IndexAbbreviations.vue");
}
function loadEditionPDF() {
    // this function will open a new tab with the pdf
    return () =>
        import(/* webpackChunkName: "doc" */ "./pages/EditionStandard.vue");
}

const routes = [
    { name: "home", path: "/", component: loadHomepage() },
    {
        name: "document",
        path: "/texte/detail/:id?",
        component: loadDocumentPage(),
        props: true,
    },
    { name: "documents", path: "/texte", component: loadDocumentsPage() },
    {
        name: "bibliography",
        path: "/bibliografie/:target?",
        component: loadBibliographyPage(),
        props: true,
    },
    { name: "names", path: "/namen", component: loadIndexNamesPage() },
    {
        name: "biblePassages",
        path: "/bibelstellen",
        component: loadIndexBiblePassagesPage(),
    },
    {
        name: "motive",
        path: "/motive/:target?",
        component: loadIndexMotifsPage(),
        props: true,
    },
    { name: "impressum", path: "/impressum", component: loadImprintPage() },
    { name: "datenschutz", path: "/datenschutz", component: loadDSGVOPage() },
    {
        name: "barrierefreiheit",
        path: "/barrierefreiheit",
        component: loadAccessibilityPage(),
    },
    {
        name: "easylanguage",
        path: "/leichte-sprache",
        component: loadEasyLanguagePage(),
    },
    {
        name: "directories",
        path: "/verzeichnisse/:activeTab?",
        component: loadDirectoriesPage(),
        props: true,
    },
    { name: "search", path: "/suche", component: loadSearchPage() },
    { name: "texttoc", path: "/textverzeichnis", component: loadTextTocPage() },
    {
        name: "team",
        path: "/projekt/team",
        component: loadTeamPage(),
        props: true,
    },
    {
        name: "manuscripttoc",
        path: "/handschriftenverzeichnis/:sigil?",
        component: loadManuscriptTocPage(),
        props: true,
    },
    {
        name: "incunabletoc",
        path: "/druckschriftenverzeichnis/:sigil?",
        component: loadIncunableTocPage(),
        props: true,
    },
    {
        name: "help-page",
        path: "/hilfe/:section?",
        component: loadDocumentationPage(),
        props: true,
    },
    { name: "network", path: "/netzwerk", component: loadNetworkPage() },
    { name: "project", path: "/projekt", component: loadProjectPage() },
    { name: "licences", path: "/lizenzen", component: loadLicences() },
    {
        name: "technic",
        path: "/technik",
        component: loadTechnicalDocumentation(),
    },
    { name: "citation", path: "/zitieren", component: loadCitationPage() },
    {
        name: "abbreviations",
        path: "/abkuerzungen",
        component: loadAbbreviationsPage(),
    },
    {
        name: "editionPDF",
        path: "/projekt/edition",
        component: loadEditionPDF(),
        props: true,
    },
    {
        name: "transcribus",
        path: "/projekt/transkribus",
        component: () =>
            import(
                /* webpackChunkName: "transcribus" */ "./pages/Transcribus.vue"
            ),
    },
    {
        name: "dvn",
        path: "/dvn",
        component: () => import("./pages/Dvn.vue"),
    },
    { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash, top: 60 };
        }
        if (savedPosition) return savedPosition;
        return { left: 0, top: 0 };
    },
});

export default router;
